/*
 * @Author: zjg
 * @Date: 2020-04-14 15:14:33
 * @LastEditTime: 2020-04-29 17:39:03
 * @Deccription: 第一个状态的标识
 */
export default {
  LENOVO_DATA: 'LENOVO_DATA',
  Theme_Change: 'themeChange',
  GET_LENOVO_LANGUAGE: 'GET_LENOVO_LANGUAGE',
  SWITCH_LENOVO_LANGUAGE: 'SWITCH_LENOVO_LANGUAGE',
  GET_USER_INFO: 'GET_USER_INFO',
  GET_SESSION: 'GET_SESSION',
  GET_LENOVO_ACCOUNT_INFO: 'GET_LENOVO_ACCOUNT_INFO',
  GET_LENOVO_CUSTOMIZE_INFO: 'GET_LENOVO_CUSTOMIZE_INFO',
  GET_CNAME: 'GET_CNAME',
  GET_USER_ROLE: 'TYPES.GET_USER_ROLE',
  // 获取当前文件的信息
  GET_CUR_FILE_INFO: 'GET_CUR_FILE_INFO',
  // 获取当前文件预览的信息
  GET_PREVIEW_INFO: 'GET_PREVIEW_INFO',
  // 全局提示toast
  GET_TOAST_INFO: 'GET_TOAST_INFO',
  // 是否为幻灯片模式
  GET_IS_SIDEMODE: 'GET_IS_SIDEMODE',
  // 右侧栏是否展开
  GET_IS_RIGHTOPEN: 'GET_IS_RIGHTOPEN',
  // 新手引导，关闭新手引导
  GET_AFTER_GUIDE: 'GET_AFTER_GUIDE',
  // 获取预览倒计时
  // GET_COUNT_DOWN: 'GET_COUNT_DOWN',
  // 是否显示底部栏
  GET_FOOTER_ISHIDE: 'GET_FOOTER_ISHIDE',
  // 存储新手引导信息用于关闭后不要丢失其他引导信息
  SET_GUIDE_INFO: 'SET_GUIDE_INFO',
  // 设置当前请求的状态
  SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
  // 切换右侧栏tab
  CHANGE_RIGHT_TAB: 'CHANGE_RIGHT_TAB',
  // 历史版本信息
  GET_HISTORY_INFO: 'GET_HISTORY_INFO',
  SET_CUR_VERSIONNUM: 'SET_CUR_VERSIONNUM',
  SET_SELECT_PID: 'SET_SELECT_PID',
  SET_SELECT_NSID: 'SET_SELECT_NSID',
}
